module.exports = __webpack_public_path__ + "media/images/sprites/green-f8f1ecd92950a1233ba4de5a0a82fb47.png";